export default __webpack_public_path__ + "static/media/logo-white.db174f3a.svg";